
export default {
  title: 'FightCamp Endurance Kit',
  id: 'fightcamp_endurance_kit_deal',
  price: 0,
  oldPrice: 17900,
  category: 'accessory',
  description: '',
  img_url: '',
  fbid: '',
  types: ['Bundles'],
};
